import optionsMenuPopoverTemplate from './options-menu-popover.html';
import mediaSettingsPopoverTemplate from './media-settings-popover.html';

/* @ngInject */
export const templates = function ($templateCache) {
	$templateCache.put('video-scene/options-menu-popover.html', optionsMenuPopoverTemplate);
	$templateCache.put('video-scene/media-settings-popover.html', mediaSettingsPopoverTemplate);
};
